<app-print-layout-matDialog (imprimir)="onImprimir()" (fechar)="onFechar()" [retrato]="false"
    titulo="Impressão Programa de Trabalho">

    <div class="card-body">

        <div>
            <div class="row mb-1">
                <div class="col-md-12" style="font-weight: bold; font-size: 18pt; text-align: center;">
                    Programa de Trabalho - {{model.unidadeGestora?.nome}}
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12">
                    <div>Nº da Ordem de Serviço de Execução: {{numeroOsa}}</div>
                    <div>Unidade Gestora Auditada: {{model.unidadeGestora?.nome}}</div>
                    <div>Equipe Responsável: {{model.equipeResponsavel}}</div>
                    <div>Data de Preenchimento: {{ model?.dataPreenchimento | date:'dd/MM/yyyy' }}</div>
                </div>
                <div class="col-md-12" style="padding-top: 15px;">
                    <table class="table" style="border: 1px solid #ccc; border-collapse: collapse; width: auto;">
                        <thead>
                            <tr>
                                <th colspan="3" style="width: 460px; text-align: center; border: 1px solid #ccc;">
                                    Questão de Auditoria
                                </th>
                                <th style="width: 300px; text-align: center; border: 1px solid #ccc;">
                                    Critério aplicável
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Avaliação
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Observações
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Constatações
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Evidências
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Critérios Infrigidos
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Riscos Associados
                                </th>
                                <th style="width: 130px; text-align: center; border: 1px solid #ccc;">
                                    Controles Associados
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <ng-container *ngFor="let item of model.questoes">
                                <tr>
                                    <td [attr.rowspan]="item.constatacoes?.length || 1"
                                        style="width: 60px; border: 1px solid #ccc; vertical-align: middle;">
                                        {{ item.tipoDesc }}
                                    </td>

                                    <td [attr.rowspan]="item.constatacoes?.length || 1"
                                        style="width: 60px; border: 1px solid #ccc; vertical-align: middle;">
                                        {{ item.identificador }}
                                    </td>

                                    <td [attr.rowspan]="item.constatacoes?.length || 1"
                                        style="width: 340px; border: 1px solid #ccc; vertical-align: middle;">
                                        {{ item.descricao }}
                                    </td>

                                    <td [attr.rowspan]="item.constatacoes?.length || 1"
                                        style="width: 300px; border: 1px solid #ccc;"
                                        [innerHTML]="item.criterioAplicavel">
                                    </td>

                                    <td [attr.rowspan]="item.constatacoes?.length || 1"
                                        style="width: 130px; border: 1px solid #ccc;">
                                        {{ item.avaliacaoDesc }}
                                    </td>

                                    <td [attr.rowspan]="item.constatacoes?.length || 1"
                                        style="width: 130px; border: 1px solid #ccc;">
                                        {{ item.observacao }}
                                    </td>

                                    <!-- PRIMEIRA CONSTATAÇÃO -->
                                    <ng-container
                                        *ngIf="item.constatacoes && item.constatacoes.length > 0; else semConstatacao">
                                        <td style="width: 130px; border: 1px solid #ccc;">
                                            {{ item.constatacoes[0].identificador }}<br />{{ item.constatacoes[0].titulo
                                            }}
                                        </td>

                                        <td style="width: 130px; border: 1px solid #ccc;"
                                            [innerHTML]="item.constatacoes[0].evidenciasLista">
                                        </td>

                                        <td style="width: 130px; border: 1px solid #ccc;"
                                            [innerHTML]="item.constatacoes[0].criteriosInfrigidos">
                                        </td>

                                        <td style="width: 130px; border: 1px solid #ccc;"
                                            [innerHTML]="item.constatacoes[0].riscosLista">
                                        </td>

                                        <td style="width: 130px; border: 1px solid #ccc;"
                                            [innerHTML]="item.constatacoes[0].controlesLista">
                                        </td>
                                    </ng-container>

                                    <ng-template #semConstatacao>
                                        <td style="border: 1px solid #ccc;"></td>
                                        <td style="border: 1px solid #ccc;"></td>
                                        <td style="border: 1px solid #ccc;"></td>
                                        <td style="border: 1px solid #ccc;"></td>
                                        <td style="border: 1px solid #ccc;"></td>
                                    </ng-template>
                                </tr>

                                <!-- DEMAIS CONSTATAÇÕES -->
                                <ng-container *ngIf="item.constatacoes && item.constatacoes.length > 1">
                                    <tr *ngFor="let c of item.constatacoes.slice(1)">
                                        <td style="border: 1px solid #ccc;">
                                            {{ c.identificador }}<br />
                                            {{ c.titulo }}
                                        </td>

                                        <td style="border: 1px solid #ccc;" [innerHTML]="c.evidenciasLista">
                                        </td>

                                        <td style="border: 1px solid #ccc;" [innerHTML]="c.criteriosInfrigidos">
                                        </td>

                                        <td style="border: 1px solid #ccc;" [innerHTML]="c.riscosLista">
                                        </td>

                                        <td style="border: 1px solid #ccc;" [innerHTML]="c.controlesLista">
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    </div>
</app-print-layout-matDialog>